import apiService from './api';
import { addDaysYmd, formatAppDate } from '../utils/appTimezone';

const consultationRestDayService = {
  get(consultationId) {
    return apiService.get(`/consultations/${consultationId}/rest-days`);
  },

  save(consultationId, payload) {
    return apiService.put(`/consultations/${consultationId}/rest-days`, payload);
  },

  cancel(consultationId) {
    return apiService.delete(`/consultations/${consultationId}/rest-days`);
  },

  list(params = {}) {
    return apiService.get('/rest-days', { params });
  }
};

export default consultationRestDayService;

export function computeEndDateLocal(startDate, daysCount) {
  if (!startDate || !daysCount) return '';
  return addDaysYmd(String(startDate).slice(0, 10), Number(daysCount) - 1);
}

export function formatDateFr(isoDate) {
  if (!isoDate) return '—';
  return formatAppDate(`${String(isoDate).slice(0, 10)}T12:00:00`, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}
